import { render, staticRenderFns } from "./AnalogueClockEditWidget.vue?vue&type=template&id=83ad5e6e&"
import script from "./AnalogueClockEditWidget.vue?vue&type=script&lang=ts&"
export * from "./AnalogueClockEditWidget.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports